import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "customer-create-dialog modal-footer"
};
var _hoisted_2 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_divider = _resolveComponent("el-divider");

  var _component_CustomerCreateForm = _resolveComponent("CustomerCreateForm");

  var _component_el_scrollbar = _resolveComponent("el-scrollbar");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.modalVisibility,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return _ctx.modalVisibility = $event;
    }),
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    width: "80%",
    style: {
      "padding": "0px",
      "padding-top": "10px"
    }
  }, {
    title: _withCtx(function () {
      return [_createElementVNode("h2", null, _toDisplayString(_ctx.$t("customer.title")), 1), _createVNode(_component_el_divider, {
        class: "mb-0"
      })];
    }),
    footer: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        class: "py-5 px-6",
        loading: _ctx.isLoading,
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _ctx.onSave();
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.save")), 1)];
        }),
        _: 1
      }, 8, ["loading"]), _createVNode(_component_el_button, {
        class: "py-5 px-6",
        type: "primary",
        loading: _ctx.isLoading,
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.onSave(true);
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.save-select")), 1)];
        }),
        _: 1
      }, 8, ["loading"])])];
    }),
    default: _withCtx(function () {
      return [_createVNode(_component_el_scrollbar, {
        "max-height": _ctx.maxHeight
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_CustomerCreateForm, {
            ref: "customerCreateForm"
          }, null, 512)];
        }),
        _: 1
      }, 8, ["max-height"])];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}